// extracted by mini-css-extract-plugin
module.exports = {"footer":"DpFooter_footer__8z6do","error":"DpFooter_error__gQBh6","close":"DpFooter_close__33BHR","done":"DpFooter_done__2GA2D","now":"DpFooter_now__K-3WA"};